import * as React from 'react';
import { SwiperSlide } from 'swiper/react';

import { FormAggregationEntity } from 'entities/FormAggregation';

import { Slider } from '../Slider';

import { SkeletonPlaceholder } from './SkeletonPlaceholder';
import SummaryIndicatorItem from './SummaryIndicatorItem';
import { SUMMARY_INDICATORS_SLIDER_PARAMS } from './config';

type SummaryIndicatorsSliderProps = {
  data: FormAggregationEntity['aggregationRow'] | null;
  fetching?: boolean;
};

const SummaryIndicatorsSlider: React.FC<SummaryIndicatorsSliderProps> = ({
  data,
  fetching,
}) => {
  /** Если загрузка уже завершена, а данных нет, то вернём null */
  if (!fetching && data?.length === 0) {
    return null;
  }

  return (
    <Slider
      slidesPerView={SUMMARY_INDICATORS_SLIDER_PARAMS.SLIDES_PER_VIEW}
      spaceBetween={SUMMARY_INDICATORS_SLIDER_PARAMS.SPACE_BETWEEN}
      breakpoints={SUMMARY_INDICATORS_SLIDER_PARAMS.BREAKPOINTS}
    >
      {fetching ? (
        <SkeletonPlaceholder />
      ) : (
        data?.map((item) => (
          <SwiperSlide key={item.id}>
            <SummaryIndicatorItem entity={item} />
          </SwiperSlide>
        ))
      )}
    </Slider>
  );
};

export default React.memo(SummaryIndicatorsSlider);
